(function () {
  'use strict';

  angular
    .module('app.page-customer-employees', []);
})();
